export default __webpack_public_path__ + "static/react-83088efde08a5dedde9f67a954cb4b5b.jpg";